export default async function fetchJSON(url: string, options?: {}) {
  return fetch(url, options).then(async (res) => ({
    status: res.status,
    json: await res.json(),
  }));
}
